import React from 'react';
import { MapPin, FileText } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-300 py-16" data-id="element-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-9">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-10">
          <div className="col-span-1 lg:col-span-2" data-id="element-11">
            <h2 className="text-2xl font-bold text-white mb-4" data-id="element-12">Playcraft</h2>
            <p className="text-gray-400 max-w-sm mb-6" data-id="element-13">
              Making investment accessible, understandable, and profitable for
              beginners in Poland.
            </p>
            <div className="flex items-start gap-3 text-sm text-gray-400" data-id="element-14">
              <MapPin className="h-5 w-5 text-emerald-500 shrink-0 mt-0.5" data-id="element-15" />
              <address className="not-italic" data-id="element-16">
                ul. BOGDAŃSKIEGO 8/---
                <br data-id="element-17" />
                34-500 ZAKOPANE
                <br data-id="element-18" />
                Poland
              </address>
            </div>
          </div>

          <div data-id="element-19">
            <h3 className="text-white font-semibold mb-4" data-id="element-20">Company</h3>
            <ul className="space-y-3 text-sm" data-id="element-21">
              <li data-id="element-22">
                <a href="#how-it-works" className="hover:text-emerald-400 transition-colors" data-id="element-23">
                  How it Works
                </a>
              </li>
              <li data-id="element-24">
                <a href="#services" className="hover:text-emerald-400 transition-colors" data-id="element-25">
                  Services
                </a>
              </li>
              <li data-id="element-26">
                <a href="#why-us" className="hover:text-emerald-400 transition-colors" data-id="element-27">
                  Why Choose Us
                </a>
              </li>
              <li data-id="element-28">
                <a href="#" className="hover:text-emerald-400 transition-colors" data-id="element-29">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-30">
            <h3 className="text-white font-semibold mb-4" data-id="element-31">Legal</h3>
            <div className="space-y-3 text-sm" data-id="element-32">
              <div className="flex items-center gap-2" data-id="element-33">
                <FileText className="h-4 w-4 text-gray-500" data-id="element-34" />
                <span data-id="element-35">CZARNY STAW KRS 0000735526</span>
              </div>
              <p className="text-xs text-gray-500 mt-4" data-id="element-36">
                Investment involves risk. Past performance is not indicative of
                future results.
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm" data-id="element-37">
          <p data-id="element-38">© 2026 Playcraft. All rights reserved.</p>
          <p className="text-gray-500" data-id="element-39">Designed for beginners.</p>
        </div>
      </div>
    </footer>;
}